import request from '@/utils/request'

// 查询信誉情况列表
export function listReputation(query) {
  return request({
    url: '/screen/creditlibrary/reputation/list',
    method: 'get',
    params: query
  })
}

// 查询信誉情况详细
export function getReputation(pid) {
  return request({
    url: '/screen/creditlibrary/reputation/detail/' + pid,
    method: 'get'
  })
}

// 新增信誉情况
export function addReputation(data) {
  return request({
    url: '/screen/creditlibrary/reputation/add',
    method: 'post',
    data: data
  })
}

// 修改信誉情况
export function updateReputation(data) {
  return request({
    url: '/screen/creditlibrary/reputation/edit',
    method: 'post',
    data: data
  })
}

// 删除信誉情况
export function delReputation(pid) {
  return request({
    url: '/screen/creditlibrary/reputation/delete/' + pid,
    method: 'get'
  })
}
